import { Icon } from '@iconify/react'
import React from 'react'

import { Button, Popover, PopoverClose, PopoverContent, PopoverTrigger } from './shadcn-ui'

interface FilterDropdownMenuProps {
  buttonLabel: string
  onReset?: () => void
  onApply?: (value: any) => void
  children?: React.ReactNode // Accept children
}

export function FilterDropDown({ buttonLabel, onReset, onApply, children }: FilterDropdownMenuProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          className="rounded-md bg-transparent p-2 hover:opacity-100"
          color="muted"
        >
          <Icon
            icon="lucide:filter"
          />

          <span className="ml-2">Filters</span>
        </Button>
      </PopoverTrigger>

      <PopoverContent className="absolute right-0 w-96 translate-x-14 p-4">
        {children}

        <div className="flex justify-between">
          <Button
            className="rounded-md bg-transparent font-medium text-muted-foreground hover:bg-transparent"
            onClick={onReset}
          >
            Reset
          </Button>

          <PopoverClose asChild>
            <Button
              className="rounded-md bg-transparent font-medium text-muted-foreground hover:bg-transparent"
              onClick={onApply}
            >
              Apply
            </Button>
          </PopoverClose>

        </div>
      </PopoverContent>
    </Popover>
  )
}
